<template>
  <div class="lg:w-2/5 mx-auto mt-16 lg:px-1 px-9 ">
    <form @submit.prevent="handleSubmit" class="rounded-lg px-8 p-9 bg-white">
      <h3>Login</h3>
      <input type="email" placeholder="Email" v-model="email" class="dash italic" />
      <input type="password" placeholder="Password" v-model="password" class="mb-9 dash italic" />
      <div v-if="error" class="error">{{ error }}</div>
      <button v-if="!isPending" class="bg-gray-200 p-1 pl-2 pr-2 rounded-lg hover:bg-gray-900 hover:text-gray-200">Log in</button>
      <button v-if="isPending" disabled>Loading...</button>
    </form>
  </div>
</template>

<script>
// using @ means start at the project src root
import useLogin from "@/composables/useLogin"
import { ref } from "vue"
import { useRouter } from "vue-router"

export default {
  setup() {
    const { error, login, isPending } = useLogin()
    const router = useRouter()

    const email = ref("")
    const password = ref("")

    const handleSubmit = async () => {
      const res = await login(email.value, password.value)
      if (!error.value) {
        router.push({ name: "Dashboard" })
      }
    }

    return { email, password, handleSubmit, error, isPending }
  },
}
</script>
